define([
    "./nlgAuditModule",
    "./nlgAuditDirective",
], function () {
});
